
$(() =>
{
    let $crossHovered = null;

    $('.is-cross-label').each((index, element) =>
    {
        const $self = $(element);
        const code = $self.data('code');
        const $ref = $(`#${code}`);

        if ($ref.length === 0)
        {
            return;
        }

        $self.on('mouseover', () =>
        {
            if ($crossHovered)
            {
                $crossHovered.removeClass('cross-hovered');
            }
            $crossHovered = $ref;
            $crossHovered.addClass('cross-hovered');
        });

        $self.on('mouseout', () =>
        {
            $ref.removeClass('cross-hovered');
            $crossHovered = null;
        });

    });

    $('svg.map-framed').each((index, element) =>
    {
        const $svg = $(element);
        const $parent = $svg.parent();
        const $tooltip = $('<div class="map-tooltip"></div>');
        $parent.append($tooltip);

        $parent.find('[data-toggle="popover-svg"]').each(function(idx, polyg)
        {
            const $self = $(polyg);

            $self.on('mouseup', () =>
            {
                const municipalityID = $self.data('id');
                if (municipalityID > 0)
                {
                    window.location.href = '/bilan/municipalite/' + municipalityID;
                }
            });

            $self.on('mouseover', () =>
            {
                $tooltip.html($self.data('content'));
                setTimeout(() =>
                {
                    $parent.addClass('-hover');
                }, 1);
            });
            $self.on('mouseout', () =>
            {
                $parent.removeClass('-hover');
            });

        });

    });

});



// WEBPACK FOOTER //
// ./resources/assets/js/components/common/svg-interactivity.js